import * as yup from 'yup'

export default function (opts) {
  const { required } = opts

  let schema = yup.array().nullable()
  if (required) {
    schema = schema.required('这是一个必填项')
    schema = schema.min(1, '这是一个必填项')
  }

  return schema
}
